module.exports = {
    // basic
    'supplement': 'suplemento',
    'section-values': 'valores de sección',
    'load-from-template': 'cargar desde plantilla',
    'dry-hole-cost': 'costo del pozo seco',
    'total-cost': 'costo total',
    'edit-files': 'editar archivos',
    'save-as-template': 'guardar como plantilla',
    'costs': 'costos',
    'cost': 'costo',
    'attach-files': 'adjuntar archivos',
    'step': 'paso',
    'approver': 'aprobador',
    'values': 'valores',
    'total': 'total',
    'note': 'nota',
    'code': 'código',
    'supplementation-method': 'método de suplementación',
    'supplementation-amount': 'cantidad de suplemento',
    'original-result': 'resultado original',
    'new-result': 'nuevo resultado',
    'result': 'resultado',
    'adjust': 'ajustar',
    'recalculate': 'recalcular',
    'global-values': 'valores globales',
    'rounding': 'redondeo',
    'load-cost-data-from-template': 'cargar datos de costos desde la plantilla',
    'ready-for-approval': 'listo para aprobación',
    'entry': 'entrada',
    'normal': 'normal',
    'both': 'ambos',
    'attached-to-well': 'pegado al pozo',
    'lease': 'arrendamiento',
    'prospect': 'prospecto',
    'description': 'descripción',
    'copy': 'copiar',

    // raw
    'shl': 'SHL',
    'bhl': 'BHL',
    'search-by-afe': 'Buscar por AFE',
    'back-to-afe': 'Volver a AFE',
    'afe': 'AFE',
    'template-afe': 'Plantilla AFE',
    'download-afe': 'Descarga AFE',
    'add-afe': 'Agregar AFE',
    'review-original-afe': 'Revisión original de AFE',
    'save-afe-as-template': 'Guardar AFE como plantilla',
    'delete-afe': 'Esta AFE se eliminará de forma permanente.\r\n\r\n¿Continuar?',
    'save-afe-as-template-warning': `Al hacer clic en Guardar, se guardará este AFE como datos de plantilla. Este no es un AFE normal (no tiene aprobaciones, no activa alertas, etc.). Eso sirve como una colección de datos AFE guardados que se pueden cargar en cualquier AFE normal sin plantilla. Todavía se puede editar en cualquier tiempo. No se puede convertir de nuevo a AFE normal.`,
    'load-afe-template-warning': `Al hacer clic en Aceptar, se reemplazarán los costos ingresados con el valor de la plantilla seleccionada. Si no existe ningún valor en la plantilla, no se reemplazará nada. Este cambio no se puede deshacer.`,
    'afe-global-value-other-section-in-use': 'Los valores globales no se pueden editar si otros usuarios han abierto otras secciones. Las siguientes secciones están abiertas actualmente.',
    'afe-global-value-other-section-complete': 'Los valores globales no se pueden editar si hay otras secciones listas para su aprobación. Las siguientes secciones están actualmente listas para su aprobación.',
    'afe-global-value-calculation-warning': 'Algunas otras secciones han tenido algún trabajo de cálculo hecho. Edición de cualquier valor global causará otros totales sección que desea borrar y tendrán que ser recalculada. Los valores de sección y los valores de los elementos de la línea permanece conservado.',
    'afe-global-value-section-complete': 'Los valores globales no se pueden editar mientras esta sección esté lista para su aprobación.',
    'afe-section-value-section-complete': 'Sección valores no se pueden editar, mientras que esta sección está listo para su aprobación.',
    'reset-afe-section-line-items': 'Esto restablecerá todos los valores de las partidas presupuestarias a cero. ¿Continuar?',
    'reset-afe-section-values': 'Esto restablecerá todos los valores de la sección a cero. ¿Continuar?',
    'reset-afe-global-values': 'Esto restablecerá todos los valores globales de nuevo a cero. ¿Continuar?',
    'current-user-has-afe-sections-open-part-1': 'Las siguientes secciones están actualmente abiertas para ser editadas por usted, y por lo tanto están bloqueadas.',
    'current-user-has-afe-sections-open-part-2': 'En cuanto termine de editar estas secciones, recuerde hacer clic en guardar para eliminar el bloqueo.',
    // template
    'opened-for-edit-by': (words) => `Abierto para editar por ${words[0]} en ${words[1]}.`,
};
